var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"slider"}},_vm._l((_vm.feturedChannels),function(feturedChannel){return _c('div',{key:feturedChannel.user_id},[_c('streamSlide',{attrs:{"focus_index":feturedChannel.focus_index,"channel_data":feturedChannel},on:{"slideClicked":function($event){return _vm.slideClicked($event)}}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7977037e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = qPv7
// module chunks = 1